import { ComponentNavigationComponent } from '../shared/components/component-navigation/component-navigation.component';
import { DeploymentRoutingModule } from './deployment-routing.module';
import { CommonModule } from '@angular/common';
import { NgModule, Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AppRoutingModule } from 'src/app/app-routing.module';
import { DeploymentGraphsComponent } from './components/deployment-graphs/deployment-graphs.component';
import { DeploymentLeftPanelComponent } from './components/deployment-left-panel/deployment-left-panel.component';
import { DeploymentListComponent } from './components/deployment-list/deployment-list.component';
import { DeploymentMainPanelComponent } from './components/deployment-main-panel/deployment-main-panel.component';
import { DeploymentSettingComopnent } from './components/deployment-setting/deployment-setting.component';
import { DeploymentSummary } from './components/deployment-summary/deployment-summary.component';
import { AngularMaterialModule } from 'src/app/shared/material-module';
import { CoreModule } from '../../core/core.module';
import { SafeHtmlPipe } from '../../core/pipes/safe-html.pipe';
import { NgxPaginationModule } from 'ngx-pagination';
import { DeleteDeploymentComponent } from './modals/delete-deployment/delete-deployment.component';
import { AddDeploymentComponent } from './modals/add-deployment/add-deployment.component';
import { SaveDeploymentSettingsComponent } from './modals/save-deployment-settings/save-deployment-settings.component';
import { DepConfirmationComponent } from './modals/dep-confirmation/dep-confirmation.component';
import { NgbModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { JobInfoDownloadComponent } from './modals/job-info-download/job-info-download.component';
import { NgChartsModule } from 'ng2-charts';
import { UpdateCredentialsComponent } from './modals/update-credentials/update-credentials.component';
import { ResizableModule } from '../../core/directive/resizable/resizable.module';
import { GoogleChartsModule } from 'angular-google-charts';
import { NgxGaugeModule } from 'ngx-gauge';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { TemplateFileUploaderComponent } from './modals/template-file-uploader/template-file-uploader.component';
import { ReportsMainPanelComponent } from './components/reports-main-panel/reports-main-panel.component';
import { ReportsDeploymentListComponent } from './components/reports-deployment-list/reports-deployment-list.component';
import { ShowAllDeploymentSessionsComponent } from './modals/show-all-deployment-sessions/show-all-deployment-sessions.component';
import { ChangeDeploymentNameComponent } from './modals/change-deployment-name/change-deployment-name.component';
import { SharedModule } from '../shared/shared.module';
import { UpdateNodeGroupComponent } from './modals/update-node-group/update-node-group.component';
import { NewDeploymentComponent } from './modals/new-deployment/new-deployment.component';
import { PowerSettingsDeploymentComponent } from './modals/power-settings-deployment/power-settings-deployment.component';
import { PoweroffConfirmationComponent } from './modals/poweroff-confirmation/poweroff-confirmation.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { UpdateClusterComponent } from './modals/update-cluster/update-cluster.component';
import { NewUpdatePartitionComponent } from './modals/new-update-partition/new-update-partition.component';
import { ConfigSectionModule } from '../pages/config-section/config-section.module';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';
import { MatStepperModule } from '@angular/material/stepper';
import { AddKvmDeploymentComponent } from './modals/add-deployment/add-kvm-deployment/add-kvm-deployment.component';
import { HomeComponent } from './components/home/home.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';

@NgModule({
  declarations: [
    // DeploymentGraphsComponent,
    DeploymentLeftPanelComponent,
    DeploymentListComponent,
    DeploymentMainPanelComponent,
    DeploymentSettingComopnent,
    DeploymentSummary,
    DeleteDeploymentComponent,
    AddDeploymentComponent,
    SaveDeploymentSettingsComponent,
    DepConfirmationComponent,
    JobInfoDownloadComponent,
    UpdateCredentialsComponent,
    DashboardComponent,
    TemplateFileUploaderComponent,
    ReportsMainPanelComponent,
    ReportsDeploymentListComponent,
    ShowAllDeploymentSessionsComponent,
    ChangeDeploymentNameComponent,
    UpdateNodeGroupComponent,
    NewDeploymentComponent,
    PowerSettingsDeploymentComponent,
    PoweroffConfirmationComponent,
    UpdateClusterComponent,
    NewUpdatePartitionComponent,
    AddKvmDeploymentComponent,
    HomeComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgxSpinnerModule,
    NgxPaginationModule,
    DeploymentRoutingModule,
    AngularMaterialModule,
    CoreModule,
    NgChartsModule,
    NgbModule,
    ResizableModule,
    GoogleChartsModule,
    NgxGaugeModule,
    SharedModule,
    NgMultiSelectDropDownModule.forRoot(),
    ConfigSectionModule,
    NgbTooltipModule,
    NgSelectModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    MatStepperModule,
    NgxMatSelectSearchModule
  ],
  exports: [
  ],
  providers: [SafeHtmlPipe]
})
export class DeploymentModule { }
